import React from 'react';
import {Card, CardBody, CardHeader, Col, Collapse, Row} from "reactstrap";
import {Button as SementicBtn, Button, Checkbox, Form} from "semantic-ui-react";
import TxtLbl from "../../../../../../components/Input/Input/TxtLbl";
import TxtAreaLbl from "../../../../../../components/Input/TextArea/TextAreaLbl";
import DrpDwn from "../../../../../../components/Dropdown/Dropdown/DrpDwn";
import Lbl from "../../../../../../components/Label/Lbl";
import {Empty, Icon as AntdIcon, Spin, TimePicker} from "antd";
import CropImageUploader from "../../../../../../components/CropImageUploader";
import FileUploader from "../../../../../../components/FileUpload/FileUpload";
import {MDBDataTable} from "mdbreact";
import * as actionCreator from "../../../../../../store/Action";
import {connect} from "react-redux";
import IntlTelInput from "react-intl-tel-input";
import * as util from "../../../../../../util/Validator";
import * as EmailValidator from "email-validator";
import Cookies from "js-cookie";
import axios_event from "../../../../../../axios/axios_eventtag";
import apiConfig from "../../../../../../axios/axios_api_services";
import * as common from "../../../../../../const/Common/CommonFunc";
import swal from "sweetalert";
import are_you_sure_icon from "../../../../../../assets/img/sweet/question.svg";
import axiosTags from "../../../../../../axios/axios_tag";
import * as innerRoutes from '../../InnerRoutes/InnerRoutes';
import success_icon from "../../../../../../assets/img/sweet/success.svg";
import error_icon from "../../../../../../assets/img/sweet/cry.svg";
import * as timeutils from "../../../../../../util/TimeConvertor";

let delete_const = 'delete';

class App extends React.Component {
  state = {
    //event

    isOldEvent:"",
    name: "",
    description: "",
    catogary: "",
    privacy: "PUBLIC",
    has_sub_event: true,
    icon: "",
    brochure: "",
    brochureLink: "",
    brochureName: "",
    //organizer
    organizer_id: 0,
    organizer_name: "",
    organizer_mobile: "",
    is_valid_mobile: true,
    organizer_email: "",
    is_mail_valid: true,
    //event details
    event_details: {},
    //sub event list
    sub_event_list: []

  };

  componentWillMount() {
    this.props.callAllEventCategories();
  }

  componentDidMount() {
    if (!this.props.current_event || this.props.current_event === '' || this.props.current_event === null) {
      if(this.props.usr_obj.userRoles ==="CORP_ADMIN") {
        this.props.history.push(innerRoutes.cor_inner_route_allEvents);
      } else {
        this.props.history.push(innerRoutes.inner_route_allEvents);
      }

    } else {
      this.fillData();
      this.props.pgChangeHandler(2);
    }
  }

  updateSubEvent = (row, index) => {
    this.props.setCurrentSubEvent(index);

    if(this.props.usr_obj.userRoles ==="CORP_ADMIN") {
      this.props.history.push(innerRoutes.cor_inner_route_event_sub_events_sub_event);
    } else {
      this.props.history.push(innerRoutes.inner_route_event_sub_events_sub_event);
    }

  };

  onchangeHandler = name => event => {
    let value = event.target.value;
    switch (name) {
      case 'name':this.setState({name: value});break;
      case 'description':this.setState({description: value});break;
      case 'organizer_name':this.setState({organizer_name: value});break;
      case 'organizer_mobile':
        let regex = new RegExp('[^0-9]');
        if(!regex.test(value)) {
          if(value.length<11) {
            if(value.length<10) {
              this.setState({
                is_valid_mobile: true,
                organizer_mobile: value
              });
            } else {
              this.setState({
                is_valid_mobile: false,
                organizer_mobile: value
              });
            }
          }
        }
        // let onlyDigit = new RegExp("^\\d+$");
        // let b = !regex.test(value);
        // if (onlyDigit.test(value) || value.length === 0) {
        //   let isValidMobile = util.mobileNumValidator(value, "ALL", 1);
        //   if (isValidMobile) {
        //     this.setState({
        //       is_valid_mobile: true,
        //       organizer_mobile: value
        //     });
        //   } else {
        //     this.setState({
        //       is_valid_mobile: false,
        //       organizer_mobile: value
        //     });
        //   }
        // }
        break;
      case 'organizer_email':
        let validateEmail = EmailValidator.validate(value);
        if (validateEmail) {
          this.setState({
            organizer_email: value,
            is_mail_valid: true
          });
        } else {
          this.setState({
            organizer_email: value,
            is_mail_valid: false
          });
        }break;
      default:break;

    }

  };

  catogaryChangehandler = (e, {value}) => {
    this.setState({
      catogary: value
    });

  };

  privacyChangeHandler = () => {
    let value = (this.state.privacy === "PUBLIC") ? "PRIVATE" : "PUBLIC";
    this.setState({
      privacy: value
    });

  };

  hasSubEventChangeHandler = () => {
    this.setState({
      has_sub_event: !this.state.has_sub_event
    });

  };

  onPhoneNumberChange = e => {
    let value = e.target.value;
    // let valid = false;
    // if (value.length >= 9) {
    //   valid = true;
    // }
    // this.setState({
    //   organizer_mobile: value,
    //   is_valid_mobile: valid
    // });


    let regex = new RegExp('[^0-9]');
    if(!regex.test(value)) {
      if(value.length<11) {
        if(value.length<=10) {
          this.setState({
            is_valid_mobile: true,
            organizer_mobile: value
          });
        } else {
          this.setState({
            is_valid_mobile: false,
            organizer_mobile: value
          });
        }
      }
    }


  };

  setIcon = (image, convert) => {
    this.setState({
      icon: convert
    });

  };

  setBrochure = (file, fileName, base64) => {
    this.setState({
      brochure: file,
      brochureLink: base64,
      brochureName: fileName
    });

  };

  fillEventData = (event) => {

    let isOldEvent = event.end_time;
    let org_id = event.event_contact_list[0].event_contact_id;
    let org_name = event.event_contact_list[0].name;
    let org_contact = event.event_contact_list[0].contact;
    let org_email = event.event_contact_list[0].email;
    this.setState({
      isOldEvent: isOldEvent,
      name: event.event_name !== null ? event.event_name: "",
      description: event.description !== null ? event.description : "",
      catogary: event.category_id,
      privacy: event.privacy,
      has_sub_event: event.has_sub_event,
      icon: event.icon!==null?event.icon:"",
      brochureLink: event.brochure!== null?event.brochure:"",
      brochureName: "",
      brochure: event.brochure!== null?event.brochure:"",
      //organizer
      organizer_id: org_id,
      organizer_name: org_name,
      organizer_mobile: org_contact,
      is_valid_mobile: true,
      organizer_email: org_email,
      is_mail_valid: true,
    });

  };

  fillSubEventData = (arr, event_id) => {
    this.getAllSubEvents(event_id);
  };

  getAllSubEvents = (eventId) => {
    this.props.spinnerHandler(true);

    let corporateId = this.props.usr_obj.corporates[0].corporateId;

    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8"),
      "Content-Type": "application/json"
    };
    axios_event.get(apiConfig.GET_ALL_SUB_EVENT({event_id: eventId, corporateId: corporateId}), {headers: headers})
      .then(response => {
        if (response.data.success) {
              let arr = response.data.subEventList;
              if(arr === undefined || arr === null || arr === "") {
                  arr = [];
              }
              this.setState({sub_event_list: arr});
              this.props.setCurrentSubEventsData(arr);
        } else {
          // common.warningAlert(response.data.message, 1)
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.getAllSubEvents(eventId);
        }
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      });
  };


  fillData = () => {
    if (this.props.current_event === "") {
      this.props.history.push("/eventtags/events");
    } else {
      this.fillEventData(this.props.current_event);
      // this.fillSubEventData(this.props.current_sub_events);
      this.fillSubEventData(this.props.current_event.subEvents, this.props.current_event.event_id);
      // if(this.props.current_sub_events === undefined || this.props.current_sub_events === null ) {
      //   this.fillSubEventData([]);
      // }
    }
  };

  newSubEvent = () => {
    this.props.setCurrentSubEvent('');

    if(this.props.usr_obj.userRoles ==="CORP_ADMIN") {
        this.props.history.push(innerRoutes.cor_inner_route_event_sub_events_sub_event);
    } else {
        this.props.history.push(innerRoutes.inner_route_event_sub_events_sub_event);
    }
  };

  editSubEvent = (row) => {
    this.state.name.trim() === '' ? common.notifyMessage("Please enter event name") :
      this.state.description.trim() === '' ? common.notifyMessage("Please enter event description") :
        this.state.catogary === ''? common.notifyMessage("Please select event category"):
        this.state.icon === '' ? common.notifyMessage("Please set event icon") :
          // this.state.brochure === ''? common.notifyMessage("Please set event brochure"):
          this.state.organizer_name.trim() === '' ? common.notifyMessage("Please enter event organizer name") :
            this.state.organizer_mobile.trim() === '' ? common.notifyMessage("Please enter event organizer mobile") :
              !this.state.is_valid_mobile ? common.notifyMessage("Please enter valid event organizer mobile") :
                this.state.organizer_email.trim() === '' ? common.notifyMessage("Please enter event organizer email") :
                  !this.state.is_mail_valid ? common.notifyMessage("Please enter valid event organizer email") :
                    this.checkPrivacyChangeOrNot();

  };

  //following method use for create new sub event
  // this method use to check privay of this event change or not with new changes
  checkPrivacyChangeOrNot = () => {
    if (this.state.privacy !== this.props.current_event.privacy && this.props.current_sub_events.length !== 0) {
      swal({
        title: "You change privacy from " + this.props.current_event.privacy + " to " +
          this.state.privacy + " so, all sub event of this event will change into " + this.state.privacy +
          ".\n Please click Ok to continue.",
        icon: are_you_sure_icon,
        closeOnClickOutside: false,
        buttons: {
          cancel: 'Cancel',
          dangerMode: {
            text: "Ok",
            value: "action",
            className: "okay-btn"
          }
        },
      }).then((value) => {
        switch (value) {
          case "action":
            this.sendChangesToBackend();
            break;
          default:
            break;
        }
      });
    } else {
      this.sendChangesToBackend();
    }

  };

  //following methods use for edit, manage-participants, view and delete
  sendChangesToBackend = () => {
    let coperateId = this.props.usr_obj.corporates[0].corporateId;
    let obj = {
      event_id: this.props.current_event.event_id,
      event_name: this.state.name,
      description: this.state.description,
      has_sub_event: this.state.has_sub_event,
      privacy: this.state.privacy,
      start_time: "",
      end_time: "",
      icon: this.state.icon,
      brochure: (typeof this.state.brochure === 'string')? this.state.brochure===''?null:this.state.brochure: null,
      // qr_code: this.props.current_event.qr_code,
      qr_code: "",
      invitation_image: "",
      category_id: this.state.catogary,
      corporate_id: coperateId,
      created_by: this.props.current_event.created_by,
      event_contact_list: [
        {
          event_contact_id: this.state.organizer_id,
          name: this.state.organizer_name,
          email: this.state.organizer_email,
          contact: this.state.organizer_mobile
        }
      ]
    };

    this.props.spinnerHandler(true);
    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8"),
      "Content-Type": "application/json"
    };
    axios_event.patch(apiConfig.UPDATE_CORPORATE_EVENT({corporateId: coperateId}), obj, {headers: headers})
      .then(response => {
        if (response.data.success) {

          if(typeof this.state.brochure === 'string') {
            common.warningAlert("Event successfully updated", 0);
            this.refreshData(response.data.eventList);
          } else {
            this.sendBrochureToBackEnd(response.data.eventList.event_id,response.data.eventList);
          }

        } else {
          common.warningAlert(response.data.message, 1)
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.sendChangesToBackend()
        }
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      });
  };

  sendBrochureToBackEnd = (event_id, content) => {

    if(this.state.brochure!==undefined && this.state.brochure!==null && this.state.brochure!=="") {
      this.props.spinnerHandler(true);

      let file_upload_state = false;
      let catch_error = false;
      let brochureUrl = null;

      let formData = new FormData();
      formData.append('id', event_id);
      formData.append('file', this.state.brochure);
      formData.append('type', 'EVENT_BROCHURE_PDF');

      let corporateId = this.props.usr_obj.corporates[0].corporateId;

      const headers = {
        "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8"),
        'content-type': 'multipart/form-data'
      };
      axios_event.put(apiConfig.SEND_BROCHURE_FILES({corporateId: corporateId}), formData, {headers: headers})
        .then(response => {
          if(response.data.success){
            file_upload_state = true;
            catch_error = false;
            content.brochure = response.data.url;
            this.refreshData(content);
          }else{
            common.warningAlert(response.data.message, 1);
            file_upload_state = false;
            catch_error = false;
          }
        })
        .catch(async error => {
          let result = await common.checkErrorResponse(error);
          if (result === 1) {
            this.sendBrochureToBackEnd(event_id, content)
          } else {
            file_upload_state = false;
            catch_error = true;
          }
        })
        .finally(fin => {

          if(file_upload_state) {

            this.props.setCurrentEventData(content);
            swal({
              title: "The event created successfully!",
              icon: success_icon,
              closeOnClickOutside: false,
              buttons: {
                dangerMode: {
                  text: "Okay",
                  value: "action",
                  className: "okay-btn"
                }
              }
            })
              .then((value) => {
                switch (value) {

                  case "action":
                    break;
                  default:
                }
              });

          } else {
            if(catch_error) {
              swal({
                title: "The event created successfully! But, the Brochure upload failed.\"",
                icon: success_icon,
                closeOnClickOutside: false,
                buttons: {
                  dangerMode: {
                    text: "Okay",
                    value: "action",
                    className: "okay-btn"
                  }
                }
              })
                .then((value) => {
                  switch (value) {
                    case "action":
                      break;
                    default:
                  }
                });

            } else {
              this.props.setCurrentEventData(content);
              swal({
                title: "The event created successfully! But, the Brochure upload failed.\"",
                icon: error_icon,
                closeOnClickOutside: false,
                buttons: {
                  dangerMode: {
                    text: "Okay",
                    value: "action",
                    className: "okay-btn"
                  }
                }
              })
                .then((value) => {
                  switch (value) {
                    case "action":
                      break;
                    default:
                  }
                });
            }
          }
          this.props.spinnerHandler(false);
        });
    } else {
      this.refreshData(content);
      this.props.setCurrentEventData(content);
      swal({
        title: "The event created successfully!",
        icon: success_icon,
        closeOnClickOutside: false,
        buttons: {
          dangerMode: {
            text: "Okay",
            value: "action",
            className: "okay-btn"
          }
        }
      })
        .then((value) => {
          switch (value) {

            case "action":
              break;
            default:
          }
        });
    }

  };


  refreshData = (data) => {

    // let sub_event_array = data.subEvents;
    //set redux
    this.props.setCurrentEventData(data);
    // this.props.setCurrentSubEventsData(sub_event_array);

    //set state
    this.setState({
      //event
      name: data.event_name !== null ? data.event_name : "",
      description: data.description !== null ? data.description : "",
      catogary: data.category_id,
      privacy: data.privacy,
      has_sub_event: data.has_sub_event,
      icon: data.icon,
      brochureLink: data.brochure!== null?data.brochure:"",
      brochureName: "",
      brochure: data.brochure!== null?data.brochure:"",
      //organizer
      organizer_id: data.event_contact_list[0].event_contact_id,
      organizer_name: data.event_contact_list[0].name,
      organizer_mobile: data.event_contact_list[0].contact,
      is_valid_mobile: true,
      organizer_email: data.event_contact_list[0].email,
      is_mail_valid: true,
      //event details
      event_details: {},
      //sub event list
      // sub_event_list: sub_event_array
    });
    this.getAllSubEvents(this.props.current_event.event_id);
  };

  deleteSubEvent = (value) => {
    let name = value.name;
    let id = value.sub_event_id;
    swal({
      text: "Are you sure you want to delete this sub event? \n If so please enter \"" + delete_const + "\"",
      icon: are_you_sure_icon,
      closeOnClickOutside: false,
      content: "input",
    })
      .then((value) => {
        if (value.trim() === delete_const) {
          this.deleteSubEvent_(id)
        } else {
          common.warningAlert("Can't delete sub event", 1)
        }
      });
  };

  deleteSubEvent_ = (id) => {
    this.props.spinnerHandler(true);

    let corporateId = this.props.usr_obj.corporates[0].corporateId;

    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8"),
      "content-type": "application/json"
    };
    axios_event.delete(apiConfig.DELETE_SUB_EVENT({subEventId: id, corporateId: corporateId}), {headers: headers})
      .then(response => {
        if (response.data.success) {

          common.warningAlert("Event deleted successfully", 0);
          this.getAllSubEvents(this.props.current_event.event_id);

        } else {
          common.warningAlert(response.data.message, 1)
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.deleteSubEvent_(id)
        }
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      });
  };

  render() {


    let isOldSubEvent = false;

    if(this.state.isOldEvent !=="") {
      let etr = new Date(this.state.isOldEvent);
      if(new Date()>etr) {
        isOldSubEvent = true;
      }
    }

    let eventCategories = this.props.event_categories;
    let cat_Options = [];
    eventCategories.map((cat, index) => {
      let obj = {
        key: cat.event_category_id,
        text: cat.title,
        value: cat.event_category_id
      };
      cat_Options.push(obj);
    });

    let row = [];
    if(this.state.sub_event_list) {
      if(this.state.sub_event_list !== undefined ) {
        if( this.state.sub_event_list.length !== 0) {
          this.state.sub_event_list.map((value, index) => {
            row.push({
              Sub_Event_Name: value.name,
              Start_Date: timeutils.YYYYMMDDHHMMSSUTCToLocalDateTime(value.start_time),
              End_Date: timeutils.YYYYMMDDHHMMSSUTCToLocalDateTime(value.end_time),
              privacy: value.privacy,
              status: value.status,
              type: value.eventType === "BOTH" ? "PHYSICAL + ONLINE" : value.eventType,
              action: <div>
                <SementicBtn circular className="btncircular" icon='edit' onClick={() => this.updateSubEvent(value, index)}/>
                <Button className="btncircular cus-btn" circular icon='trash alternate'
                        onClick={() => this.deleteSubEvent(value)}/>
              </div>
            });

          });
        }
      }
  }
    let columns = this.props.table_data.columns;
    let table_data = {columns, row};

    return (
      <div>
        <Row>
          <Col xs="12" lg={"12"} md={"12"} className={"padd_grap"}>
            <Card>
              <CardHeader>
                Event Details
              </CardHeader>
              <Collapse isOpen={true} id="collapseExample">
                <CardBody>

                  <Row style={{padding: '10px'}}>
                    <Col lg={6}>
                      <Form>
                        <Form.Group widths='equal'>
                          <TxtLbl
                            required
                            tagText={"Event Name"}
                            placeholder={"Event name"}
                            value={this.state.name}
                            onChange={this.onchangeHandler('name')}
                          />
                        </Form.Group>

                        <Form.Group widths='equal'>
                          <TxtAreaLbl
                            required
                            tagText={"Event Description"}
                            placeholder={"Event Description"}
                            value={this.state.description}
                            onChange={this.onchangeHandler('description')}
                          />
                        </Form.Group>

                        <Form.Group widths='equal'>
                          <DrpDwn
                            required
                            tagText={"Category"}
                            placeholder={"Select category"}
                            options={cat_Options}
                            value = {this.state.catogary}
                            onChange={this.catogaryChangehandler}
                          />

                        </Form.Group>

                        <Row className="CheckBoxRow boldText">
                          <Col lg={5} className="TimePickerCol">
                            <Checkbox style={{fontWeight: '600', color: 'rgba(72, 72, 72, 0.87)!important'}}
                              // disabled={isSubEventPrivate}
                                      label='Make Private'
                                      checked={(this.state.privacy === "PUBLIC") ? false : true}
                                      onChange={this.privacyChangeHandler}
                            />
                          </Col>
                        </Row>

                        <Row className="CheckBoxRow boldText">
                          <Col lg={5} className="TimePickerCol">
                            <Checkbox style={{fontWeight: '600', color: 'rgba(72, 72, 72, 0.87)!important'}}
                                      disabled
                                      toggle
                                      label='Has Sub Events'
                                      defaultChecked={this.state.has_sub_event}
                                      onChange={this.hasSubEventChangeHandler}
                            />
                          </Col>
                        </Row>
                      </Form>

                      <Row style={{padding: '10px'}}>
                        <hr style={{width: '100%'}}/>

                        <Row>
                          <Col lg={6}>
                            <Form>
                              <Form.Group widths='equal'>
                                <TxtLbl
                                  style={{marginTop: '10px'}}
                                  required
                                  tagText={"Event Organizer Name"}
                                  placeholder={"Show in the app"}
                                  value={this.state.organizer_name}
                                  onChange={this.onchangeHandler('organizer_name')}
                                />
                              </Form.Group>
                            </Form>
                          </Col>

                          <Col lg="6">
                            <Form>
                              <Form.Group widths='equal'>
                                <TxtLbl
                                  style={{marginTop: '10px'}}
                                  required
                                  tagText={"Event Organizer Mobile"}
                                  placeholder={"Show in the app"}
                                  value={this.state.organizer_mobile}
                                  onChange={this.onPhoneNumberChange}
                                />
                              </Form.Group>
                            </Form>
                          </Col>

                          <Col lg={12} style={{marginTop: '10px'}}>
                            <Form>
                              <Form.Group widths='equal'>
                                <TxtLbl
                                  required
                                  tagText={"Event Organizer Email"}
                                  placeholder={"Show in the app"}
                                  value={this.state.organizer_email}
                                  onChange={this.onchangeHandler('organizer_email')}
                                />
                              </Form.Group>
                            </Form>
                          </Col>
                        </Row>
                      </Row>
                    </Col>

                    <Col lg={6}>
                      <Row>
                        <Col xs="12" lg={"12"} md={"12"} className="textAlignCenter">
                          <Lbl required>Event Icon</Lbl>
                          <CropImageUploader propName="Event" image={this.state.icon} getImage={this.setIcon}/>
                        </Col>

                        <Col xs="12" lg={"12"} md={"12"} className="textAlignCenter">
                          <Lbl>Event Brochure</Lbl>
                          <FileUploader
                            fileStyle={"file1"} key={'1'}
                            getFile={this.setBrochure}
                            preview={this.state.brochureName}
                            blink={this.state.brochureLink}
                          />
                        </Col>
                      </Row>
                    </Col>

                  </Row>

                  <Row>
                    <Col lg={"12"} className={"text-align-path"} style={{marginBottom: '5px'}}>
                      <Button
                        className="px-5"
                        // disabled={isOldSubEvent}
                        onClick={this.editSubEvent}
                      >Save Changes</Button>
                    </Col>
                  </Row>

                </CardBody>
              </Collapse>
            </Card>
          </Col>
        </Row>

        <Row>
          <Col xs="12" lg={"12"} md={"12"} className={"padd_grap"}>
            <Card>
              <CardHeader>
                All Sub Events
              </CardHeader>
              <Collapse isOpen={true} id="collapseExample">
                <CardBody>
                  <Row style={{padding: '10px'}}>
                    <Col lg={"12"} className={"text-align-path"} style={{marginBottom: '5px', textAlign: 'end'}}>
                      <Button
                        className="px-5"
                        onClick={this.newSubEvent}>
                        <i aria-hidden="true" className="plus icon"></i>
                        Add New
                      </Button>
                    </Col>
                  </Row>

                  <Row style={{padding: '10px'}}>
                    <Col lg={12}>
                      {
                        this.state.sub_event_list.length !== 0 ?
                          <MDBDataTable
                            searching={false}
                            displayEntries={true}
                            paging={false}
                            entries={0}
                            responsive
                            responsiveSm
                            responsiveMd
                            responsiveLg
                            responsiveXl
                            bordered
                            hover
                            columns={columns}
                            rows={row}
                          />
                          : <div className={"align-center fully-width"}>
                            <Empty description={"Records not found"} className={"empty-icon"}/>
                          </div>
                      }
                    </Col>
                  </Row>
                </CardBody>
              </Collapse>
            </Card>
          </Col>
        </Row>


      </div>

    );
  }
}

const mapStateToProps = (state) => ({
  pg: state.eventReducer.pg,
  current_event: state.eventReducer.current_event,
  current_sub_events: state.eventReducer.current_sub_events,
  current_sub_event_id: state.eventReducer.current_sub_event_id,
  table_data: state.subEventReducer.Sub_Event_Table_data,
  usr_obj: state.userReducer.user,
  event_categories: state.eventReducer.all_Event_Catogaries

});

const mapDispatchToProps = (dispatch) => {
  return {
    callAllEventCategories: () => dispatch(actionCreator.callAllEventCatogaries()),
    pgChangeHandler: (data) => dispatch(actionCreator.stepActivateionEventHandler(data)),
    setCurrentEventData: (data) => dispatch(actionCreator.setCurrentEventData(data)),
    setCurrentSubEvent: (data) => dispatch(actionCreator.setCurrentSubEvent(data)),
    setCurrentSubEventsData: (data) => dispatch(actionCreator.setCurrentSubEventsData(data)),
    spinnerHandler: (data) => dispatch(actionCreator.spinnerHandler(data)),
  };

};

export default connect(mapStateToProps, mapDispatchToProps)(App);
